import { isMobile } from './platform';

/**
 * Initialize native Capacitor plugins.
 * Safe to call on web — all imports are guarded by isMobile.
 */
export async function initNative() {
  if (!isMobile) return;

  const [{ StatusBar, Style }, { SplashScreen }, { App }] = await Promise.all([
    import('@capacitor/status-bar'),
    import('@capacitor/splash-screen'),
    import('@capacitor/app'),
  ]);

  // Dark status bar matching the app background
  await StatusBar.setStyle({ style: Style.Light });
  await StatusBar.setBackgroundColor({ color: '#16161e' });

  // Hide the native splash once the React app has mounted
  await SplashScreen.hide({ fadeOutDuration: 300 });

  // Android back button: go back in history or exit the app
  App.addListener('backButton', ({ canGoBack }: { canGoBack: boolean }) => {
    if (canGoBack) {
      window.history.back();
    } else {
      App.exitApp();
    }
  });
}
